import React from 'react';
import { Tooltip, Icon } from 'antd';
import cn from 'classnames';
import styles from './NavigationToHousingStock.module.scss';

export const NavigationToHousingStock = ({ placement, title, icon, onClick }) => {
  return (
    <span className={styles.container}>
      <span className={cn(styles.btnWrap, 'dspx-ref-show')}> 
        <Tooltip placement={placement} title={title}>
          <span onClick={onClick}>
            <Icon component={icon} className={styles.icon} />
          </span>
        </Tooltip>
      </span>
    </span>
)};
